/**
 * In a roll-up, a widget either adds the roll-up's clients together (the
 * default) or reads one client, as AgencyAnalytics' Roll-up / Client widgets.
 */

import type { ReactNode } from 'react';

import { useRollup } from './rollup-context.ts';
import type { WidgetData } from './reports-api.ts';

export function RollupWidgetFields({
  data,
  setData,
}: {
  data: WidgetData;
  setData: (patch: Partial<WidgetData>) => void;
}): ReactNode {
  const rollup = useRollup();
  if (!rollup) return null;
  const chosen = rollup.clients.filter((client) => rollup.clientIds.includes(client.id));
  return (
    <label className="rs-field">
      Clients
      <select
        value={data.client_id ?? ''}
        onChange={(event) => {
          const clientId = event.target.value || null;
          // A one-client widget cannot be broken down by client.
          setData({
            client_id: clientId,
            ...(clientId && data.dimension === 'client' ? { dimension: null } : {}),
          });
        }}
      >
        <option value="">All {chosen.length} clients, added together</option>
        {chosen.map((client) => (
          <option key={client.id} value={client.id}>
            {client.name} only
          </option>
        ))}
      </select>
    </label>
  );
}
